(function () {
  'use strict';

  var config = window.AUFreeGiftConfig || {};
  var threshold = Number(config.threshold || 9900);
  var propertyKey = config.propertyKey || '_free_gift';
  var giftProductIds = Array.isArray(config.productIds)
    ? config.productIds.map(function (id) { return Number(id); })
    : [];
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var enforcing = false;
  var pendingEnforcement = null;

  function normalizeBoolean(value) {
    return value === true || value === 1 || value === '1' || value === 'true' || value === 'yes';
  }

  function isGiftItem(item) {
    if (!item) return false;
    var properties = item.properties || {};
    if (normalizeBoolean(properties[propertyKey])) return true;
    return giftProductIds.indexOf(Number(item.product_id)) !== -1;
  }

  function qualifyingSubtotal(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;
    return cart.items.reduce(function (total, item) {
      if (isGiftItem(item)) return total;
      var linePrice = Number(
        typeof item.final_line_price !== 'undefined' ? item.final_line_price : item.line_price
      ) || 0;
      return total + linePrice;
    }, 0);
  }

  function giftItems(cart) {
    if (!cart || !Array.isArray(cart.items)) return [];
    return cart.items.filter(isGiftItem);
  }

  function getState(cart) {
    var subtotal = qualifyingSubtotal(cart);
    var gifts = giftItems(cart);
    return {
      cart: cart,
      threshold: threshold,
      qualifyingSubtotal: subtotal,
      remaining: Math.max(0, threshold - subtotal),
      eligible: subtotal >= threshold,
      gifts: gifts,
      giftCount: gifts.reduce(function (count, item) { return count + Number(item.quantity || 0); }, 0)
    };
  }

  async function fetchCart() {
    var response = await fetch(root + 'cart.js', {
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      cache: 'no-store'
    });
    if (!response.ok) throw new Error('Could not load the cart.');
    return response.json();
  }

  function parseSection(sectionHtml) {
    if (!sectionHtml) return null;
    return new DOMParser().parseFromString(sectionHtml, 'text/html');
  }

  function replaceCartIcon(sectionHtml) {
    var parsed = parseSection(sectionHtml);
    if (!parsed) return;
    var next = parsed.querySelector('#cart-icon-bubble');
    var current = document.querySelector('#cart-icon-bubble');
    if (next && current) current.innerHTML = next.innerHTML;
  }

  function replaceCartDrawer(sectionHtml) {
    var parsed = parseSection(sectionHtml);
    if (!parsed) return;
    var nextInner = parsed.querySelector('#CartDrawer .drawer__inner');
    var currentInner = document.querySelector('#CartDrawer .drawer__inner');
    if (nextInner && currentInner) {
      currentInner.innerHTML = nextInner.innerHTML;
      var drawer = document.querySelector('cart-drawer');
      if (drawer) {
        drawer.classList.toggle('is-empty', !currentInner.querySelector('.cart-item'));
        var overlay = currentInner.querySelector('#CartDrawer-Overlay');
        if (overlay && typeof drawer.close === 'function') {
          overlay.addEventListener('click', drawer.close.bind(drawer));
        }
      }
    }
  }

  function replaceSectionContents(sectionHtml, sectionSelector, contentsSelector) {
    if (!sectionHtml) return;
    var parsed = parseSection(sectionHtml);
    var currentSection = document.querySelector(sectionSelector);
    if (!parsed || !currentSection) return;
    var nextContents = parsed.querySelector(contentsSelector);
    var currentContents = currentSection.querySelector(contentsSelector);
    if (nextContents && currentContents) currentContents.innerHTML = nextContents.innerHTML;
  }

  function renderSections(sections) {
    if (!sections) return;
    replaceCartDrawer(sections['cart-drawer']);
    replaceCartIcon(sections['cart-icon-bubble']);
    replaceSectionContents(sections['main-cart-items'], '#main-cart-items', '.js-contents');
    replaceSectionContents(sections['main-cart-footer'], '#main-cart-footer', '.js-contents');
    document.dispatchEvent(new CustomEvent('au:free-gift-cart-rendered'));
  }

  async function updateLines(updates, notice) {
    var response = await fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        updates: updates,
        sections: ['cart-drawer', 'cart-icon-bubble', 'main-cart-items', 'main-cart-footer'],
        sections_url: window.location.pathname
      })
    });

    var data = await response.json().catch(function () { return {}; });
    if (!response.ok) throw new Error(data.description || data.message || 'Could not update the cart.');

    if (notice) sessionStorage.setItem('auFreeGiftNotice', notice);
    renderSections(data.sections);
    return data;
  }

  function buildRuleUpdates(state) {
    var updates = {};
    var gifts = state.gifts;

    if (!state.eligible) {
      gifts.forEach(function (item) {
        updates[item.key || item.id] = 0;
      });
      return updates;
    }

    gifts.forEach(function (item, index) {
      var key = item.key || item.id;
      if (index > 0) updates[key] = 0;
      else if (Number(item.quantity || 0) !== 1) updates[key] = 1;
    });

    return updates;
  }

  async function enforce(cart) {
    if (enforcing) return pendingEnforcement || Promise.resolve(cart);

    enforcing = true;
    pendingEnforcement = (async function () {
      try {
        var currentCart = cart && Array.isArray(cart.items) ? cart : await fetchCart();
        var state = getState(currentCart);
        var updates = buildRuleUpdates(state);
        var keys = Object.keys(updates);

        if (!keys.length) return currentCart;

        var removedForThreshold = !state.eligible && state.gifts.length > 0;
        var notice = removedForThreshold
          ? 'Your free kit was removed because the qualifying merchandise in your cart fell below $99.'
          : 'Only one free kit can be included per qualifying order.';

        var updatedCart = await updateLines(updates, notice);
        return updatedCart;
      } finally {
        enforcing = false;
        pendingEnforcement = null;
      }
    })();

    return pendingEnforcement;
  }

  async function replaceGift(variantId, extraProperties) {
    var cart = await fetchCart();
    var state = getState(cart);
    if (!state.eligible) {
      var error = new Error('Your qualifying merchandise subtotal must be at least $99 to claim this gift.');
      error.code = 'NOT_ELIGIBLE';
      error.remaining = state.remaining;
      throw error;
    }

    if (state.gifts.length) {
      var removals = {};
      state.gifts.forEach(function (item) {
        removals[item.key || item.id] = 0;
      });
      await updateLines(removals);
    }

    var properties = Object.assign({}, extraProperties || {});
    properties[propertyKey] = 'true';
    properties._gift_offer = '$99+ Complete Kit Gift';

    var response = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [{
          id: Number(variantId),
          quantity: 1,
          properties: properties
        }],
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    });

    var data = await response.json().catch(function () { return {}; });
    if (!response.ok) throw new Error(data.description || data.message || 'Could not add your free kit.');

    renderSections(data.sections);
    try {
      await enforce();
    } catch (error) {
      console.warn('[Artist Unlock free gift] Post-add rule check failed:', error);
    }
    return data;
  }

  function showStoredNotice() {
    var notice = sessionStorage.getItem('auFreeGiftNotice');
    if (!notice) return;
    var host = document.querySelector('#CartDrawer .drawer__inner');
    if (!host || host.querySelector('.au-free-gift-notice')) return;

    var element = document.createElement('div');
    element.className = 'au-free-gift-notice';
    element.setAttribute('role', 'status');
    element.textContent = notice;
    var header = host.querySelector('.drawer__header');
    if (header && header.parentNode) header.parentNode.insertBefore(element, header.nextSibling);
    else host.prepend(element);

    sessionStorage.removeItem('auFreeGiftNotice');
  }

  function scheduleEnforcement(cart) {
    window.clearTimeout(window.__auFreeGiftEnforceTimer);
    window.__auFreeGiftEnforceTimer = window.setTimeout(function () {
      enforce(cart).catch(function (error) {
        console.error('[Artist Unlock free gift] Rule enforcement failed:', error);
      });
    }, 80);
  }

  function init() {
    showStoredNotice();
    scheduleEnforcement();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.source === 'au-free-gift') return;
        scheduleEnforcement(event && event.cartData);
      });
    }

    document.addEventListener('au:free-gift-cart-rendered', showStoredNotice);
    document.addEventListener('cart:refresh', function () { scheduleEnforcement(); });
    window.addEventListener('pageshow', function () { scheduleEnforcement(); });
  }

  window.AUFreeGift = {
    fetchCart: fetchCart,
    isGiftItem: isGiftItem,
    qualifyingSubtotal: qualifyingSubtotal,
    getState: getState,
    enforce: enforce,
    replaceGift: replaceGift,
    renderSections: renderSections
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
